import * as React from "react";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization, IStartMenu } from "../../../models/localization";
import { Row, Col } from "react-flexbox-grid";
import * as s from "./tutorial.css";

@inject("store") @observer
export class Tutorial extends React.Component<{ store: SeekerStore }, {}> {

  constructor(props: any) {
    super(props);
  }

  render(): JSX.Element {
    const localization: ILocalization = this.props.store.localization.fields;
    const local: IStartMenu = this.props.store.localization.fields.startMenu;
    const icon1: string = "images/icon1.png";
    const icon2: string = "images/icon2.png";
    const icon3: string = "images/icon3.png";
    return (<Col xs={12} className={s.container}>
      <Row>
        <Col xs={12}><h3 className={s.header}>{local.tutorialHeader}</h3></Col>
      </Row>
      <Row around="xl">
        <Col xs={12} sm={4} xl={3}>
          <Row>
            <Col xs={12}><h4 className={s.subHeader}>{local.stepOneHeader}</h4></Col>
            <Col xs={12} className={s.iconCol}><img src={icon1} className={s.icon} /></Col>
            <Col xs={12}><p>{local.stepOneText}</p></Col>
          </Row>
        </Col>
        <Col xs={12} sm={4} xl={3}>
          <Row>
            <Col xs={12}><h4 className={s.subHeader}>{local.stepTwoHeader}</h4></Col>
            <Col xs={12} className={s.iconCol}><img src={icon2} className={s.icon} /></Col>
            <Col xs={12}><p>{local.stepTwoText}</p></Col>
          </Row>
        </Col>
        <Col xs={12} sm={4} xl={3}>
          <Row>
            <Col xs={12}><h4 className={s.subHeader}>{local.stepThreeHeader}</h4></Col>
            <Col xs={12} className={s.iconCol}><img src={icon3} className={s.icon} /></Col>
            <Col xs={12}><p>{local.stepThreeText}</p></Col>
          </Row>
        </Col>
      </Row>
    </Col>)
  }
}


// WEBPACK FOOTER //
// ./src/components/start/tutorial/index.tsx